import { NoOptionsMessage } from './NoOptionsMessage';

export default NoOptionsMessage;
